import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "mb-0 alert alert-danger"
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_banner = _resolveComponent("banner")
  const _component_b_col = _resolveComponent("b-col")
  const _component_b_row = _resolveComponent("b-row")
  const _component_welcome = _resolveComponent("welcome")
  const _component_no_shiptos = _resolveComponent("no-shiptos")
  const _component_contact_us = _resolveComponent("contact-us")
  const _component_pay_online = _resolveComponent("pay-online")
  const _component_bucket = _resolveComponent("bucket")
  const _component_b_container = _resolveComponent("b-container")

  return (_openBlock(), _createBlock(_component_b_container, { fluid: "" }, {
    default: _withCtx(() => [
      ($data.company !== 'Portal')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_b_row, { class: "mt-3 d-none d-md-block" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_banner, {
                      "country-code": $options.user.countryCode,
                      company: $data.company
                    }, null, 8, ["country-code", "company"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_b_row, { class: "mt-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, {
            xs: "8",
            lg: "8"
          }, {
            default: _withCtx(() => [
              ($options.showBannerMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($data.bannerMessage.bannerTextMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_b_row, { class: "mt-3" }, {
        default: _withCtx(() => [
          ($options.revalidationStatus === 'RequiresRevalidation')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('ml_113926')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_b_row, { class: "mt-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, {
            xs: "8",
            lg: "8"
          }, {
            default: _withCtx(() => [
              ($options.shipTos.length || $options.hasMriApplication || $options.hasN2MembraneSizing)
                ? (_openBlock(), _createBlock(_component_welcome, {
                    key: 0,
                    company: $data.company,
                    country: $options.user.countryCode,
                    premium: $options.user.premium,
                    mobile: $options.user.mobile
                  }, null, 8, ["company", "country", "premium", "mobile"]))
                : _createCommentVNode("", true),
              ($options.shipTos.length === 0)
                ? (_openBlock(), _createBlock(_component_no_shiptos, {
                    key: 1,
                    company: $data.company
                  }, null, 8, ["company"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, {
            xs: "4",
            lg: "4"
          }, {
            default: _withCtx(() => [
              ($data.phoneNumbers.length && $options.showNeedHelp)
                ? (_openBlock(), _createBlock(_component_contact_us, {
                    key: 0,
                    numbers: $data.phoneNumbers
                  }, null, 8, ["numbers"]))
                : _createCommentVNode("", true),
              ($options.hasInvoiceApplication && $options.showPayOnline)
                ? (_openBlock(), _createBlock(_component_pay_online, {
                    key: 1,
                    class: "mt-1"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      ($options.shipTos.length || $options.hasMriApplication || $options.hasN2MembraneSizing)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["mt-3 bucketWrapper", { disabled: $options.revalidationStatus === 'RequiresRevalidation' }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.buckets, (bucket, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (index < 6)
                  ? (_openBlock(), _createBlock(_component_bucket, {
                      image: $options.bucketImagePath(bucket.image),
                      text: _ctx.$t(bucket.stringId),
                      url: bucket.link,
                      key: bucket.stringId
                    }, null, 8, ["image", "text", "url"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}